import { DELETE, GET, PATCH, POST } from "../../axios/apiService";

export const getIntegrations = async ({ options }) => {
  const url = `${process.env.REACT_APP_API_BASE_URL}/api/v1/workspace-settings/integrations`;
  return GET(url, options);
};

export const installIntegration = async ({ data, key, options }) => {
  const url = `${process.env.REACT_APP_API_BASE_URL}/api/v1/workspace-settings/integrations/${key}`;
  return POST(url, data, options);
};

export const deleteIntegration = async ({ configId, options }) => {
  const url = `${process.env.REACT_APP_API_BASE_URL}/api/v1/workspace-settings/integrations/config/${configId}/uninstall`;
  return DELETE(url, options);
};

export const updateIntegration = async ({ data, options, configId }) => {
  const url = `${process.env.REACT_APP_API_BASE_URL}/api/v1/workspace-settings/integrations/config/${configId}`;
  return POST(url, data, options);
};

export const requestIntegration = async ({ data, options }) => {
  const url = `${process.env.REACT_APP_API_BASE_URL}/api/v1/workspace-settings/integrations/request`;
  return POST(url, data, options);
};

export const getEnrichmentIntegrations = async ({ options }) => {
  const url = `${process.env.REACT_APP_API_BASE_URL}/api/v1/enrich/integrations/active`;
  return GET(url, options);
};

export const enableConfig = async (data) => {
  const url = `${process.env.REACT_APP_API_BASE_URL}/api/v1/workspace-settings/integrations/config/${data.id}/enable`;
  return POST(url, undefined, data.options);
};
export const disableConfig = async (data) => {
  const url = `${process.env.REACT_APP_API_BASE_URL}/api/v1/workspace-settings/integrations/config/${data.id}/disable`;
  return POST(url, undefined, data.options);
};

export const getEnrichmentPriorityConfig = async ({ options }) => {
  const url = `${process.env.REACT_APP_API_BASE_URL}/api/v1/workspace-settings/integrations/enrichment-config-priority`;
  return GET(url, options);
};

export const setEnrichmentPriorityConfig = async ({ data, options }) => {
  const url = `${process.env.REACT_APP_API_BASE_URL}/api/v1/workspace-settings/integrations/enrichment-config-priority`;
  return POST(url, data, options);
};

export const crmAuthLogin = async ({ env, options, crmKey }) => {
  const url = `${process.env.REACT_APP_API_BASE_URL}/workspace-settings/integrations/${crmKey}/login/${env}`;
  return GET(url, options);
};

export const getCRMObjectList = async ({ options, crmConfigId, crmKey }) => {
  const url = `${process.env.REACT_APP_API_BASE_URL}/api/v1/workspace-settings/integrations/${crmConfigId}/${crmKey}/objects`;
  return GET(url, options);
};

export const saveCRMObjectsConfig = async ({ data, crmConfigId, crmKey, options }) => {
  const url = `${process.env.REACT_APP_API_BASE_URL}/api/v1/workspace-settings/integrations/${crmConfigId}/${crmKey}/configuration/objects`;
  return POST(url, data, options);
};

export const getSavedCRMConfig = async ({ options, crmConfigId, crmKey }) => {
  const url = `${process.env.REACT_APP_API_BASE_URL}/api/v1/workspace-settings/integrations/${crmConfigId}/${crmKey}/configuration/objects`;
  return GET(url, options);
};

export const getPlatformFields = async ({ options, type }) => {
  const url = `${process.env.REACT_APP_API_BASE_URL}/api/v1/workspace-settings/integrations/crm/system-fields`;
  return GET(url, options);
};

export const getCRMObjectFields = async ({ options, object, crmConfigId, crmKey }) => {
  const url = `${process.env.REACT_APP_API_BASE_URL}/api/v1/workspace-settings/integrations/${crmConfigId}/${crmKey}/objects/${object}`;
  return GET(url, options);
};

export const saveCRMObjectsMapping = async ({ data, crmConfigId, crmKey, type, options }) => {
  const url = `${process.env.REACT_APP_API_BASE_URL}/api/v1/workspace-settings/integrations/${crmConfigId}/${crmKey}/configuration/objects/${type}/fields`;
  return POST(url, data, options);
};

export const updateCRMObjectsConfig = async ({ data, crmConfigId, crmKey, objectId, options }) => {
  const url = `${process.env.REACT_APP_API_BASE_URL}/api/v1/workspace-settings/integrations/${crmConfigId}/${crmKey}/configuration/objects/${objectId}`;
  return PATCH(url, data, options);
};

export const deleteCRMObjectsConfig = async ({ crmConfigId, crmKey, objectId, options }) => {
  const url = `${process.env.REACT_APP_API_BASE_URL}/api/v1/workspace-settings/integrations/${crmConfigId}/${crmKey}/configuration/objects/${objectId}`;
  return DELETE(url, options);
};

export const getCRMUserMapping = async ({ options, crmConfigId, crmKey, type }) => {
  const url = `${process.env.REACT_APP_API_BASE_URL}/api/v1/workspace-settings/integrations/${crmConfigId}/${crmKey}/configuration/user-mapping`;
  return GET(url, options);
};

export const saveCRMUserMapping = async ({ data, crmConfigId, crmKey, type, options }) => {
  const url = `${process.env.REACT_APP_API_BASE_URL}/api/v1/workspace-settings/integrations/${crmConfigId}/${crmKey}/configuration/user-mapping`;
  return POST(url, data, options);
};
